import { ImportUserGroupRef } from './dtos';

/** What the import will do to this row once the admin submits. */
export type ImportPlan = '' | 'Add' | 'Update' | 'No Change' | 'Reject';

/** What the import actually did, after the save. */
export type ImportOutcome = '' | 'Added' | 'Updated' | 'No Change' | 'Skipped' | 'Failed';

/**
 * One row of an Account User Import, from spreadsheet cell to saved outcome.
 *
 * Three fields carry the row through the process and they are deliberately separate:
 *   Plan     — what WILL happen, recomputed every time a code mapping changes
 *   Details  — why, in words the admin can act on
 *   Outcome  — what DID happen, set only after a save attempt
 */
export class ImportUser {
  Id = '';

  /** '' until planned. See ImportPlan. */
  Plan: ImportPlan = '';

  /**
   * Plain-language account of what an Update will change, or why a row is rejected.
   * Several clauses are joined with '; ' when more than one rule fires.
   */
  Details = '';

  /** '' until submitted. See ImportOutcome. */
  Outcome: ImportOutcome = '';

  // --- From the spreadsheet ---
  LastName = '';
  FirstName = '';
  MiddleName = '';
  Email = '';
  Salutation = '';
  Gender = '';
  ApiLink? = '';
  HireDate?;
  ShippingUserGroupCode? = '';
  ProgramUserGroupCode? = '';

  // --- Resolved by the code-mapping grids ---
  ShippingUserGroupId? = '';
  ShippingUserGroupName? = '';
  ProgramUserGroupId? = '';
  ProgramUserGroupName? = '';

  /** Server-generated for an Add; the existing username for a Match. */
  UserName? = '';

  // --- From the server's identity pass (PlanAccountUserImport) ---

  /** Set when the row matched somebody already on the account. */
  MatchedAccountUserId? = '';
  MatchedProximityUserId? = '';
  /** "First Last" of the matched person, for Details. */
  MatchedDisplayName? = '';
  /** What the matched person's ApiLink is now. Empty means rule 3 can fill it. */
  ExistingApiLink? = '';
  /** What the matched person's Hire Date is now. Null means rule 4 can fill it. */
  ExistingHireDate?: Date;
  /** Shipping Groups the matched person belongs to now. Rule 5 compares against this. */
  ExistingShippingGroups: ImportUserGroupRef[] = [];
  /** Program Groups the matched person belongs to now. Rule 6 compares against this. */
  ExistingProgramGroups: ImportUserGroupRef[] = [];
}
